import { SudoButton } from "src/sudokit/components/SudoButton";
import { WithReset } from "src/sudokit/Layout/BoxReset";
import { Text } from "src/sudokit/components/Text";

type StoryBibleEntityLoadStatusProps = {
  entityLabel: "characters" | "worldbuilding entries";
  hasContent: boolean;
  hasError: boolean;
  isLoading: boolean;
  onRetry: () => void;
};

export const StoryBibleEntityLoadStatus = ({
  entityLabel,
  hasContent,
  hasError,
  isLoading,
  onRetry,
}: StoryBibleEntityLoadStatusProps) => {
  if (isLoading && !hasContent) {
    return (
      <WithReset
        className="flex w-full items-center justify-center px-4 py-6"
        aria-busy="true"
        aria-live="polite"
        role="status"
      >
        <Text color="grey-1">Loading {entityLabel}…</Text>
      </WithReset>
    );
  }

  if (!hasError) return null;

  return (
    <WithReset
      className="mx-2 mb-3 flex w-[calc(100%_-_16px)] items-center justify-between gap-4 rounded-xl border border-solid border-app-grey-3 bg-app-menu-color px-4 py-3"
      aria-live="assertive"
      role="alert"
    >
      <div className="flex min-w-0 flex-col gap-1">
        <Text color="grey-0" weight="medium">
          We couldn’t {hasContent ? "refresh" : "load"} your {entityLabel}.
        </Text>
        <Text color="grey-1" size="sm">
          {hasContent ? "Showing the last version loaded for this project." : "Your saved content has not been deleted."}
        </Text>
      </div>
      <SudoButton
        variant="secondary"
        size="small"
        onClick={onRetry}
        aria-label={`Retry loading ${entityLabel}`}
      >
        Try again
      </SudoButton>
    </WithReset>
  );
};
